/* eslint-disable react/prop-types */
/* eslint-disable arrow-body-style */
/* eslint-disable react/self-closing-comp */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable prettier/prettier */
import { DeleteOutline } from '@mui/icons-material';
import { Box, IconButton, ImageList, ImageListItem, ImageListItemBar, Radio } from '@mui/material';
import React from 'react';
import { useDropzone } from 'react-dropzone';

export default ({
  handleFiles,
  files,
  handleSelected,
  selectedIndex,
  handleDeletedFiles,
  multiple
}) => {
  const { getRootProps, getInputProps } = useDropzone({
    multiple,
    accept: 'image/*',
    onDrop: (acceptedFiles) => {
      handleFiles(
        acceptedFiles.map((file) =>
          Object.assign(file, {
            preview: URL.createObjectURL(file)
          })
        )
      );
    }
  });

  const deleteImage = (img) => {
    console.log(files);
    let _files = [];
    const deletedImgIndex = files.map((t) => t.preview).indexOf(img.preview);
    if (files[deletedImgIndex]) handleDeletedFiles(files[deletedImgIndex].id);
    _files = _files.concat(files.slice(0, deletedImgIndex), files.slice(deletedImgIndex + 1));
    handleFiles(_files);
  };

  const thumbs = () => {
    return files && files.length > 0 ? (
      <ImageList
        sx={{
          width: '100%',
          marginTop: '26px'
        }}
        variant="quilted"
        cols={6}
        gap={8}
      >
        {files.map((file, index) => (
          <ImageListItem onClick={() => handleSelected(index)} key={file.name}>
            <img src={file.preview} loading="lazy" />
            <ImageListItemBar
              title={
                <IconButton
                  onClick={() => deleteImage(file)}
                  aria-label="upload picture"
                  component="span"
                >
                  <DeleteOutline />
                </IconButton>
              }
              actionIcon={<Radio checked={selectedIndex === index} />}
            />
          </ImageListItem>
        ))}
      </ImageList>
    ) : null;
  };

  return (
    <Box
      sx={{
        padding: '25px',
        border: 1,
        borderRadius: 6
      }}
    >
      <Box
        component="div"
        sx={{
          cursor: 'pointer',
          width: '100%',
          textAlign: 'center'
        }}
        {...getRootProps()}
      >
        <input {...getInputProps()} />
        <p>Przeciągnij i upuść pliki tutaj lub kliknij aby wybrać!</p>
      </Box>
      {thumbs()}
    </Box>
  );
};
